import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

interface ConfirmOrdersModalProps {
  show: boolean;
  onHide: () => void;
  onConfirm: () => void;
  confirming: boolean;
  message: string;
}

export const ConfirmOrdersModal = ({
  show,
  onHide,
  onConfirm,
  confirming,
  message,
}: ConfirmOrdersModalProps) => {
  return (
    <Modal show={show} onHide={onHide} backdrop="static" centered>
      <Modal.Header closeButton>
        <Modal.Title>Confirm Orders</Modal.Title>
      </Modal.Header>
      <Modal.Body>{message}</Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide} disabled={confirming}>
          Cancel
        </Button>
        <Button variant="primary" onClick={onConfirm} disabled={confirming}>
          {confirming ? "Confirming" : "Confirm"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
